import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(() => !localStorage.getItem(KEY));

  useEffect(() => {
    const reopen = () => setVisible(true);
    window.addEventListener("open-cookie-settings", reopen);
    return () => window.removeEventListener("open-cookie-settings", reopen);
  }, []);

  if (!visible) return null;

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Consentement aux cookies"
      className="fixed inset-x-3 bottom-16 z-[60] mx-auto max-w-lg rounded-xl border border-slate-200 bg-white p-5 shadow-2xl sm:bottom-20"
    >
      <div className="flex items-start gap-3">
        <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-[#2BB08A]" aria-hidden="true" />
        <div>
          <h2 className="font-display text-sm font-semibold text-[#0B1F3A]">
            Respect de votre vie privée
          </h2>
          <p className="mt-1 text-[13px] leading-relaxed text-slate-600">
            Nous n'utilisons aucun cookie publicitaire ni traceur d'affiliation. Seules des
            statistiques de fréquentation anonymisées peuvent être activées, avec votre accord.{" "}
            <Link to="/cookies" className="underline transition-colors hover:text-[#2BB08A]">
              En savoir plus
            </Link>
          </p>
        </div>
      </div>
      <div className="mt-4 flex gap-3">
        <button
          type="button"
          data-testid="cookie-refuse"
          onClick={() => choose("refused")}
          className="flex-1 rounded-full border border-slate-300 px-4 py-2.5 font-display text-sm font-semibold text-slate-700 transition-colors hover:border-slate-400 hover:bg-slate-50"
        >
          Refuser
        </button>
        <button
          type="button"
          data-testid="cookie-accept"
          onClick={() => choose("accepted")}
          className="flex-1 rounded-full bg-[#0B1F3A] px-4 py-2.5 font-display text-sm font-semibold text-white transition-colors hover:bg-[#16305a]"
        >
          Accepter
        </button>
      </div>
    </div>
  );
}
